const getImageUrlOfS3 = ({src, stageId}) => {
    // return `http://mz-cm-s3-load-balancer-246963362.ap-northeast-2.elb.amazonaws.com/v1/stages/${stageId}/redirect?url=${encodeURIComponent(src)}`;
    //TODO 임시조치
    return src;
};

export default getImageUrlOfS3;